import React from 'react';
import styled from 'astroturf/react';

import { ResearchInterest } from './types';

interface Props {
  researchInterests: Array<ResearchInterest>;
  onAdd(ri: ResearchInterest): void;
}

const Container = styled.div`
  z-index: 2;
  width: calc(100% - 2px);
  max-height: 200px;
  position: absolute;
  margin-top: -1px;
  border-radius: 0 0 4px 4px;
  border-color: rgba(82, 168, 236, 0.8);
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.15);
  overflow-x: hidden;
  overflow-y: auto;
  background-color: white;
`;

const ResultContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 7px 4px 7px;
  cursor: pointer;
  min-height: 1em;
  border-bottom: 1px solid #ddd;

  &:last-of-type {
    border-bottom: none;
  }

  &:hover {
    background: #f4f4f4;
  }
`;

const ResultName = styled.span`
  font-size: 85%;
  max-width: 350px;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ResultWeight = styled.span`
  color: #999;
  font-weight: 300;
  font-size: 85%;
`;

export default function ResearchInterestSearchResults(props: Props) {
  const { researchInterests, onAdd } = props;

  const results = researchInterests.map((ri) => (
    <ResultContainer
      key={ri.id}
      onClick={() => onAdd(ri)}
      title={ri.displayName}
    >
      <ResultName>{ri.displayName}</ResultName>
      <ResultWeight>
        {ri.weight}&nbsp;{ri.weightDescription}
      </ResultWeight>
    </ResultContainer>
  ));

  return <Container>{results}</Container>;
}
